export const getApplications = async ({ commit }, { vm }) => {
  let response = await vm.axios.get("/api/applications/?format=json");
  commit("setApplications", response.data);
  return response.data;
};

export const getProvinces = async ({ commit }, { vm }) => {
  let response = await vm.axios.get("/api/provinces/?format=json");
  commit("setProvinces", response.data);
  return response.data;
};
